import { UtilsService } from './../../../../services/utils.service';
import { Category } from './../../../generics/data-printer/data-printer.component';
import { Office } from './../../../../models/office.model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-office-details-content',
  templateUrl: './office-details-content.component.html',
  styleUrls: ['./office-details-content.component.scss']
})
export class OfficeDetailsContentComponent implements OnInit {

    private officeContent?: Office;
    @Input()
    set office(of: Office) {
        this.officeContent = of;
        this.updateCategories();
    }
    get office() {
        return this.officeContent;
    }

    categories: Category[] = [];

    constructor(
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
    }

    updateCategories() {
        if (!this.office) return;
        this.categories = [
            { name: 'Información general', items: [
                { label: 'Nombre', value: this.office.nombre },
                { label: 'Nro. sucursal', value: this.office.sucursal },
                { label: 'Teléfono', value: this.office.telefonoFijo, type: 'phone' },
                { label: 'CUIT', value: this.office.cuit, type: 'cuit' },
            ]}, { name: 'Dirección', items: [
                { label: 'Tipo de vía', value: this.office.direccion?.tipoCalle },
                { label: 'Calle', value: this.office.direccion?.calle },
                { label: 'Número', value: this.office.direccion?.numero },
                { label: 'Piso', value: this.office.direccion?.piso },
                { label: 'Departamento', value: this.office.direccion?.departamento },
                { label: 'Código postal', value: this.office.direccion?.codigoPostal },
                { label: 'Provincia', value: this.office.direccion?.localidad?.provincia?.descripcion },
                { label: 'Municipio', value: this.office.direccion?.localidad?.municipio?.descripcion },
                { label: 'Localidad', value: this.office.direccion?.localidad?.descripcion },
            ]}, { name: 'Sujeto responsable', items: [
                { label: 'Nombre', value: this.office.nombreResponsable },
                { label: 'Apellido', value: this.office.apellidoResponsable },
                { label: 'Teléfono', value: this.office.celular, type: 'phone' },
                { label: 'E-Mail', value: this.office.email, type: 'email' },
            ]}, { name: 'Servicios', items: this.office.servicios?.map(service => ({ value: service.servicio?.nombre + ' - ' + service.tipoCotizacion }))}
        ];
    }

}
